const messages = {
  units: {
    points: "pont",
    piecesCount: "{count} db.",
    piecesCountUnit: "db.",
  },
  account: {
    title: "Számlaegyenleg",
    noPointsYet: "Még nincsenek pontok",
    loading: "Számlaegyenleg betöltése…",
    lastUpdate: "Utolsó frissítés: {date}",
    toggleToPurchases: "Vásárlások megjelenítése",
    toggleToFirstStop: "First Stop számlaegyenleg megjelenítése",
    firstStopPanelButton: "First Stop panel",
  },
  purchases: {
    title: "VÁSÁRLÁSAI",
    carMinimum: "min. 20 db.",
    busMinimum: "min. 12 db.",
    bikeMinimum: "min. 10 db.",
    detailsButton: "Vásárlás részletei",
  },
  quickLinks: {
    rules: {
      title: "Szenvedély szabályai",
      subtitle: "és a pótdíj táblázat",
    },
    promotions: {
      title: "Időkorlátos promóciók",
      subtitle: "és különleges kampányok",
    },
    knowledge: {
      title: "BRIDGESTONE Go",
      subtitle: "Tudás és jutalmak",
    },
  },
  bonusUhrd: {
    title: "Bonus UHRD",
    pointsLabel: "+75 pont",
    goalLabel: "Célod: {count} db.",
    goalAchievedLabel: "Cél teljesítve: {count} db.",
    beyondGoalPointsLabel: "+15 pont",
    beyondGoalPointsPerUnit: "/db.",
    beyondGoalTotalPointsLabel: "+180",
    beyondGoalTotalPointsUnit: "pont",
    mockGoalAchievedToggle: "Mock: cél teljesítve",
    detailsButton: "Bónusz részleteinek megtekintése",
    regsButton: "Szabályzat",
  },
  bonusUhrdPage: {
    crumbHome: "Kezdőlap",
    crumbBonus: "Bonus UHRD",
    heroHeadline: "Szerezz bónusz pontokat nagy méretekért",
    goalReminderEyebrow: "MÁR CSAK ELÉRZŐ UTAT",
    goalReminderDaysLeftLead: "Van még előtted ",
    goalReminderDaysLeftEmphasis: "{days} nap",
    bonusPeriodLine: "Időszak: 01.01.2026 – 31.12.2026",
    periodLead: "Időszak:",
    periodDates: "01.01.2026 – 31.12.2026",
    rulesHeading: "Egyszerű szabályok",
    rules: {
      passengerTyres: {
        title: "VÁSÁROLJ UHRD GUMIKAT",
        description:
          "Bónuszpontokat 18” és nagyobb személyautó-abroncsok vásárlásáért kapsz.",
      },
      achieveAdv: {
        title: "ÉRD EL A CÉLOD",
        points: "+75 pont",
        description: "Ha eléred a célod, megkapod az első bónuszt:",
      },
      challengeAdv: {
        title: "MÉG TÖBB PONT!",
        description:
          "A cél fölötti minden abroncsért +15 pont jár (maximum +10 000 pont!)",
      },
      rewardsHighlighted: {
        title: "JUTALMAK PONTÉRT",
        description:
          "A megszerzett pontok a program végén válthatók be a Bridgestone jutalomkatalógusában.",
      },
    },
  },
  bonusGoals: {
    title: "Beszerzési célok",
  },
  bonusGoalsPage: {
    crumbHome: "Kezdőlap",
    crumbBonus: "Beszerzési célok",
    heroHeadline: "Teljesítsd a beszerzési célokat és gyűjts bónusz pontokat",
    goalReminderEyebrow: "MÁR CSAK ELÉRZŐ UTAT",
    goalReminderDaysLeftLead: "Van még előtted ",
    goalReminderDaysLeftEmphasis: "{days} nap",
    bonusPeriodLine: "Időszak: 01.01.2026 – 31.12.2026",
    rulesHeading: "Egyszerű szabályok",
    rules: {
      passengerTyres: {
        title: "PONTOK A CÉLOKÉRT",
        description:
          "A körök és előírások megtalálhatók a kampánykommunikációban és a kiegészítő táblában.",
      },
      achieveAdv: {
        title: "ELSŐ SZINT",
        points: "+2 000 pont",
        description:
          "Az első határ elérésekor jogosultság keletkezik a prémium bónuszpontra:",
      },
      challengeAdv: {
        title: "MAGASABB SZINT",
        points: "+3 000 pont",
        description:
          "További limit teljesítése további prémium pontot ad a kampány szerint:",
      },
      rewardsHighlighted: {
        title: "JUTALMAK PONTÉRT",
        description:
          "A megszerzett pontok a program végén válthatók a Bridgestone jutalomkatalógusában.",
      },
    },
  },
  bonusAwansPage: {
    crumbHome: "Kezdőlap",
    crumbBonus: "ELŐLÉPTETÉSI BÓNUSZ",
    heroHeadline: "Lépd át a beszerzési küszöböket — extra bónusz pontok várnak",
    goalReminderEyebrow: "MÁR CSAK ELÉRZŐ UTAT",
    goalReminderEyebrowRemaining: "Már csak",
    goalReminderDaysLeftLead: "Van még előtted ",
    goalReminderDaysLeftEmphasis: "{days} nap",
    bonusPeriodLine: "Időszak: 01.01.2026 – 31.12.2026",
    periodLead: "Időszak: ",
    periodDates: "01.01.2026 - 31.12.2026",
    periodNote: ". A bónuszok nem adódnak össze — a legmagasabbat kapod meg.",
    rulesHeading: "Egyszerű szabályok",
    rules: {
      passengerTyres: {
        title: "VALÓSÍTSD MEG A PROGRAM VÁSÁRLÁSAIT",
        description:
          "Az előrehaladást az aktuális kampánykommunikáció és a Bridgestone dopní tábla határozza meg.",
      },
      achieveAdv: {
        title: "ELSŐ KÜSZÖB — AWANS",
        points: "+2 000 pont",
        description:
          "Az első darabszám-küszöb elérésekor jár az előléptetési prémium:",
      },
      challengeAdv: {
        title: "MAGASABB KÜSZÖB — AWANS",
        points: "+3 000 pont",
        description:
          "A magasabb küszöb további bónuszpontokat ad a kampányfeltételek szerint:",
      },
      rewardsHighlighted: {
        title: "JUTALMAK PONTÉRT",
        description:
          "A pontokat az időszak zárása után válthatod be a katalógusban.",
      },
    },
  },
  bonusAwans: {
    title: "ELŐLÉPTETÉSI BÓNUSZ",
    detailsButton: "Bónusz részleteinek megtekintése",
    mockFirstMilestoneAchievedToggle: "Mock: első küszöb teljesítve",
    milestones: {
      goal: {
        pointsLabel: "+2000 pont",
        label: "A célod: 200 db.",
        achievedLabel: "Cél teljesítve: {count} db.",
      },
      challenge: {
        pointsLabel: "+3000 pont",
        label: "menni fog? 400 db.",
        remainingLabel: "Már csak {count} db.",
      },
    },
  },
  analytics: {
    pointsVsLastYear: {
      title: "Megszerzett pontok vs. előző év",
    },
    tiresVsLastYear: {
      title: "Rendelt gumiabroncsok vs. előző év",
    },
    purchasesByInch: {
      title: "Vásárlások coll szerint",
    },
    purchasesBySupplier: {
      title: "Vásárlások nagykereskedő szerint",
    },
    view: {
      chart: "Grafikon",
      table: "Táblázat",
    },
    legend: {
      lastYear: "előző év",
      thisYear: "idén",
    },
    tireType: "Gumiabroncs típusa",
    tireTypes: {
      all: "Összes",
      passenger: "Személygépkocsi",
      truck: "Teher",
    },
    downloadXls: "Letöltés .xls",
    table: {
      month: "Hónap",
      label: "Kategória",
      percent: "Arány %",
    },
    months: {
      jan: "jan",
      feb: "feb",
      mar: "már",
      apr: "ápr",
      may: "máj",
      jun: "jún",
      jul: "júl",
      aug: "aug",
      sep: "szep",
      oct: "okt",
      nov: "nov",
      dec: "dec",
    },
    inch: {
      15: '15"',
      16: '16"',
      17: '17"',
      18: '18"',
      19: '19"',
      20: '20"',
    },
    suppliers: {
      interCars: "Inter Cars",
      handlopex: "Handlopex",
      latex: "Latex",
    },
    surchargeTable: {
      title: "Pótléktáblázat",
      diameterHeader: "Gumiabroncs átmérő",
      andMore: "és nagyobb",
      note1:
        "A táblázat az 1 db gumiabroncs vásárlásáért járó pontok számát mutatja márka és átmérő szerint.",
      note2: "A pontok a minimális darabszám elérése után aktiválódnak.",
      rulesButton: "Szabályok megtekintése",
    },
  },
  promotions: {
    heading:
      "Használja ki az összes promóciót, és gyűjtse a maximális pontokat!",
    pageBrandLabel: "Bridgestone Plus",
    pageTitle: "Promóciók",
    pageIntro:
      "Tekintse meg az összes aktív promóciót, jelentkezzen azokra, amelyek ezt igénylik, és maximalizálja a gumiabroncs-vásárlásért járó pontokat.",
    pageListHeading: "Összes elérhető promóció",
    filtersAriaLabel: "Promóciók szűrése",
    filterAll: "Összes",
    filterActive: "Aktív",
    filterSignInRequired: "Regisztráció szükséges",
    filterSigned: "Regisztrálva",
    viewAll: "Összes promóció megtekintése",
    detailsLink: "Promóció részletei",
    backToHome: "Vissza a főoldalra",
    backToList: "Vissza a promóciók listájához",
    loading: "Promóciók betöltése…",
    listView: "Lista nézet",
    sliderView: "Csúszka nézet",
    cardButton: "Promóció igénybevétele",
    signInButton: "Jelentkezés a promócióra",
    signedInButton: "Jelentkezve a promócióra",
    signInSuccess: "Sikeresen jelentkezett a promócióra.",
    signInError: "A promócióra való jelentkezés nem sikerült. Próbálja újra.",
    detailDescriptionTitle: "Promóció leírása",
    detailRulesTitle: "Szabályok",
    detailRelatedTitle: "További promóciók",
    detailRewardLabel: "Jutalom",
    detailInfoTitle: "Információk",
    detailInfoStatus: "Állapot",
    detailInfoStart: "Kezdés",
    detailInfoEnd: "Vége",
    detailInfoBonus: "Bónusz",
    detailHelpTitle: "Segítségre van szüksége?",
    detailHelpText:
      "Kérdése van ezzel a promócióval kapcsolatban? Lépjen kapcsolatba velünk.",
    detailHelpContact: "Kapcsolat",
    detailNoDescription: "A promóció leírása nem érhető el.",
    detailPeriod: "Promóció időszaka: {start} – {end}",
    detailAutoApply: "A pontok a vásárlás után automatikusan jóváíródnak.",
    detailNotFound: "A promóció nem található.",
    stats: {
      total: "Összesen",
      active: "Aktív",
      signInRequired: "Regisztráció szükséges",
    },
    status: {
      active: "Aktív",
      ending_soon: "Hamarosan lejár",
      planned: "Hamarosan",
    },
    pointsLabel: {
      multiply: "x{value} több pont",
      add: "+{value} pont minden gumiabroncs után!",
    },
    items: {
      default: {
        description:
          "Az idei Bridgestone Szenvedély kiadásban akár 120 jutalom is elérhető. Számlaegyenlege legfeljebb 88 beváltását teszi lehetővé!",
      },
      doublePoints: {
        title: "Dupla pont az Ecopia Elite 60 sorozat gumiabroncsaiért",
        pointsLabel: "x2 több pont",
      },
      purchaseGoal: {
        title: "Extra pontok a beszerzési cél teljesítéséért",
        pointsLabel: "+1 pont minden gumiabroncs után!",
      },
    },
  },
  rewards: {
    catalogView: "Katalógus nézet",
    sliderView: "Csúszka nézet",
    slidesAriaLabel: "Jutalomkatalógus diai",
    showSlideAriaLabel: "{number}. dia megjelenítése",
    claimButton: "Jutalom igénylése",
    catalogTitle: "Tekintse meg a teljes jutalom KATALÓGUST",
    catalogDescriptionStart:
      "Idén akár 120 jutalom is elérhető. Jelenlegi számlaegyenlege lehetővé teszi, hogy beváltson",
    catalogDescriptionEnd: "közülük!",
    exchangeButton: "Pontok beváltása jutalmakra",
    slides: {
      race: {
        title: "A hét jutalma: egy nap a versenypályán",
        description:
          "Üljön egy ezer lóerős rali szörny kormánya mögé. Padlógáz és... RAJT!",
        points: "1400 pont",
      },
      voucher: {
        title: "Népszerű jutalom: Media Expert utalvány",
        description:
          "Telefon? TV? Valami a kertbe vagy a teraszra? Váltson be pontokat nagyszerű vásárlásokra!",
        points: "500 ponttól",
      },
    },
  },
  benefits: {
    headingStart: "Használja ki",
    headingHighlight: "az összes",
    headingEnd: "Bridgestone előnyt:",
    tabs: {
      myApps: "Alkalmazásaim",
      allApps: "Összes alkalmazás",
    },
    emptyMyApps:
      "Még nincs hozzárendelt alkalmazása. Váltson az „Összes alkalmazás” fülre, és kérjen hozzáférést.",
    openButton: "Megnyitás",
    items: {
      survey: {
        title: "Szerviz kérdőív",
        description:
          "Töltse ki kérdőívét a szervizéről, és vonzó, garantált jutalmat kap!",
      },
      collection: {
        title: "COLLECTION",
        description:
          "Válasszon jutalmakat a márka exkluzív termék- és ajándéktárából.",
      },
      drive: {
        title: "DRIVE",
        description:
          "Férjen hozzá gazdag multimédiás tartalmakhoz, amelyek segítenek az értékesítésben.",
      },
      linkup: {
        title: "LINKUP",
        description:
          "Nézze meg, milyen egyszerű az European customer care management használata.",
      },
    },
  },
  footer: {
    ariaLabel: "Lábléc",
    links: {
      rules: "Program szabályai",
      contact: "Kapcsolat",
      cookies: "Cookie-szabályzat",
      terms: "Általános szerződési feltételek",
      privacy: "Adatvédelmi irányelvek",
      faq: "FAQ",
      e8: "E8",
    },
  },
};

export default {
  messages,
};
